import React from 'react'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'

interface MapToOptionsProps {
  mapTo: string
  handleMapToChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const MapToOptions: React.FC<MapToOptionsProps> = ({
  mapTo,
  handleMapToChange,
}) => {
  const mapToOptions = [
    { value: 'LOCATION', label: 'Location' },
    { value: 'IPD', label: 'IPD' },
    { value: 'HOMEKARE', label: 'HomeKare' },
    { value: 'AMBULANCE', label: 'Ambulance' },
  ]

  return (
    <FormControl>
      <RadioGroup row value={mapTo} onChange={handleMapToChange}>
        {mapToOptions?.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            label={option.label}
            control={<Radio />}
          />
        ))}
      </RadioGroup>
    </FormControl>
  )
}
